export default "__VITE_ASSET__CNR4h86R__"